import run from '../../utilities/run';
import render from '../../utilities/render';
import _ from "underscore";
import ReturnRequestsWizardLogic from './returnRequestsWizardLogic';

// NOTE: make the target selector a place on the webpage where you want to import this
const targetSelector = "#add-rma";

const customValidateProps = {
  errorPlacement: function(error, element) {
    let appendClosest = $(element).data('error-placement-append-closest');
    if (appendClosest) {
      $(element).closest(appendClosest).append(error);
    } else {
      error.insertAfter(element);
    }
  }
};

run(targetSelector, (outerEl)=>{
 attachHtml(outerEl);
});

function attachHtml(outerEl){
  const returnRequestWizardLogicVar = new ReturnRequestsWizardLogic(outerEl);
  returnRequestWizardLogicVar.init();
};



// WEBPACK FOOTER //
// ./src/pages/returnRequestsWizard/returnRequestsWizard.js